export default __webpack_public_path__ + "static/media/todo.99abeb9b.svg";